import { Component, Input, ViewEncapsulation } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { StringFilter, StringFilterType } from '@lsq-frontend/remote-services/enterprise/common';
import { BaseFilterComponent } from '../base-filter.component';

@Component({
    selector: 'lsq-text-filter',
    template: `
        <div class="text-filter filter">
            <div class="row">
                <form [formGroup]="formGroup" class="filter-box-text-filter col-9">
                    <lsq-input
                        class="filter-box-text-filter-input"
                        [name]="'value'"
                        [formGroup]="formGroup"
                        formControlName="value"
                    >
                    </lsq-input>
                </form>
                <lsq-button
                    class="submit-button col-3"
                    type="submit"
                    (buttonClick)="emitFilterUpdate()"
                    >Ok</lsq-button
                >
            </div>
        </div>
    `,
    encapsulation: ViewEncapsulation.None,
    styleUrls: ['./lsq-text-filter.component.scss']
})
export class LsqTextFilterComponent extends BaseFilterComponent {
    @Input() public filter: StringFilter;

    public setFilterValues(): void {
        this.formGroup = new FormGroup({
            value: new FormControl(this.filter ? this.filter.value : '')
        });
    }

    public createFormGroup(): FormGroup {
        return new FormGroup({
            value: new FormControl(this.filter ? this.filter.value : '')
        });
    }

    public emitFilterUpdate(): void {
        const filterData = {
            [this.column.filterField]: new StringFilter({
                value: this.formGroup.value.value,
                stringFilterType: StringFilterType.Contains
            })
        };
        this.updated.emit(filterData);
    }
}
